import { c as throwApiError, i as createApiClient, t as MASTRA_PLATFORM_API_URL } from "./client-RyOogiHS.js";
import "module";
import { randomBytes } from "crypto";
import { readFileSync } from "fs";
import { homedir, release } from "os";
import { join } from "path";
import { chmod, mkdir, readFile, unlink, writeFile } from "fs/promises";
import * as p from "@clack/prompts";
import { execFileSync } from "child_process";
import { createServer } from "http";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region src/commands/auth/credentials.ts
var credentials_exports = /* @__PURE__ */ __exportAll({
	LoginCancelledError: () => LoginCancelledError,
	clearCredentials: () => clearCredentials,
	getCurrentOrgId: () => getCurrentOrgId,
	getToken: () => getToken,
	loadCredentials: () => loadCredentials,
	login: () => login,
	saveCredentials: () => saveCredentials,
	setCurrentOrgId: () => setCurrentOrgId,
	tryRefreshToken: () => tryRefreshToken,
	validateOrgAccess: () => validateOrgAccess,
	verifyToken: () => verifyToken
});
const CREDENTIALS_DIR = join(homedir(), ".mastra");
const CREDENTIALS_FILE = join(CREDENTIALS_DIR, "credentials.json");
var LoginCancelledError = class extends Error {
	constructor() {
		super("Login skipped.");
		this.name = "LoginCancelledError";
	}
};
async function saveCredentials(creds) {
	await mkdir(CREDENTIALS_DIR, {
		recursive: true,
		mode: 448
	});
	await writeFile(CREDENTIALS_FILE, JSON.stringify(creds, null, 2), { mode: 384 });
	await chmod(CREDENTIALS_DIR, 448).catch(() => {});
	await chmod(CREDENTIALS_FILE, 384).catch(() => {});
}
async function loadCredentials() {
	try {
		const data = await readFile(CREDENTIALS_FILE, "utf-8");
		return JSON.parse(data);
	} catch {
		return null;
	}
}
async function clearCredentials() {
	try {
		await unlink(CREDENTIALS_FILE);
	} catch {}
}
async function getCurrentOrgId() {
	const envOrgId = process.env.MASTRA_ORG_ID;
	if (envOrgId) return envOrgId;
	const creds = await loadCredentials();
	if (!creds) return null;
	return creds.currentOrgId ?? creds.organizationId;
}
async function setCurrentOrgId(orgId) {
	const creds = await loadCredentials();
	if (!creds) throw new Error("Not logged in");
	creds.currentOrgId = orgId;
	await saveCredentials(creds);
}
function isWSL() {
	if (process.platform !== "linux") return false;
	try {
		return /microsoft|wsl/i.test(release()) || /microsoft|wsl/i.test(readFileSync("/proc/version", "utf-8"));
	} catch {
		return false;
	}
}
function openBrowser(url) {
	if (process.platform === "darwin") execFileSync("open", [url]);
	else if (process.platform === "win32") execFileSync("cmd", [
		"/c",
		"start",
		"",
		url
	]);
	else if (isWSL()) execFileSync("powershell.exe", [
		"-NoProfile",
		"-Command",
		`Start-Process '${url.replace(/'/g, "''")}'`
	]);
	else execFileSync("xdg-open", [url]);
}
async function verifyToken(token, signal) {
	try {
		return (await fetch(`${MASTRA_PLATFORM_API_URL}/v1/auth/verify`, {
			headers: { Authorization: `Bearer ${token}` },
			signal
		})).ok;
	} catch {
		return false;
	}
}
async function tryRefreshToken(creds, signal) {
	if (!creds.refreshToken) return null;
	try {
		const res = await fetch(`${MASTRA_PLATFORM_API_URL}/v1/auth/refresh-token`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ refreshToken: creds.refreshToken }),
			signal
		});
		if (!res.ok) return null;
		const data = await res.json();
		creds.token = data.accessToken;
		creds.refreshToken = data.refreshToken;
		await saveCredentials(creds);
		return data.accessToken;
	} catch {
		return null;
	}
}
function callbackPage({ success }) {
	const title = success ? "Logged in!" : "Login failed";
	return `<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>${title} — Mastra</title>
    <style>
      body {
        margin: 0;
        padding: 0;
        background-color: #0d0d0d;
        color: #ffffff;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, system-ui, sans-serif;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .container {
        text-align: center;
      }
      .logo {
        margin-bottom: 1.5rem;
      }
      h1 {
        font-size: 1.75rem;
        font-weight: 600;
        margin: 0 0 0.75rem 0;
      }
      p {
        color: #9ca3af;
        font-size: 1rem;
        margin: 0;
        line-height: 1.6;
      }
    </style>
  </head>
  <body>
    <div class="container">
      <h1>${title}</h1>
      <p>${success ? "You can close this tab and return to the terminal." : "Missing parameters. Close this tab and try again."}</p>
    </div>
  </body>
</html>`;
}
function listenForSkipInput(onSkip) {
	const stdin = process.stdin;
	if (!stdin.isTTY || typeof stdin.setRawMode !== "function") return () => {};
	const wasRaw = stdin.isRaw;
	const wasPaused = stdin.isPaused();
	let listening = true;
	const cleanup = () => {
		if (!listening) return;
		listening = false;
		stdin.removeListener("data", handleInput);
		if (!wasRaw) stdin.setRawMode(false);
		if (wasPaused) stdin.pause();
	};
	const handleInput = (input) => {
		const data = typeof input === "string" ? Buffer.from(input) : input;
		cleanup();
		if (data.includes(3)) {
			process.kill(process.pid, "SIGINT");
			return;
		}
		onSkip();
	};
	stdin.setRawMode(true);
	stdin.resume();
	stdin.once("data", handleInput);
	return cleanup;
}
async function login(signal, options = {}) {
	signal?.throwIfAborted();
	console.info("\n   Logging in to Mastra...\n");
	const server = createServer();
	const state = randomBytes(16).toString("hex");
	const port = await new Promise((resolve) => {
		server.listen(0, "127.0.0.1", () => {
			const addr = server.address();
			if (typeof addr === "object" && addr) resolve(addr.port);
		});
	});
	const loginUrl = `${MASTRA_PLATFORM_API_URL}/v1/auth/login?product=cli&cli_port=${port}&state=${state}`;
	console.info(`   Opening browser...\n`);
	console.info(options.skipOnInput ? `   Waiting for browser sign-in. Press any key to skip this step.\n` : `   Waiting for browser sign-in...\n`);
	try {
		openBrowser(loginUrl);
	} catch {
		console.info(`   Could not open browser automatically.`);
		console.info(`   Open this URL manually: ${loginUrl}\n`);
		if (isWSL()) console.info(`   Note: If login times out, ensure localhost forwarding is enabled in your .wslconfig.\n`);
	}
	const result = await new Promise((resolve, reject) => {
		let settled = false;
		let stopListeningForSkip = () => {};
		const finish = (callback) => {
			if (settled) return;
			settled = true;
			clearTimeout(timeout);
			signal?.removeEventListener("abort", handleAbort);
			stopListeningForSkip();
			server.close(callback);
			server.closeAllConnections();
		};
		const handleAbort = () => {
			finish(() => reject(signal?.reason instanceof Error ? signal.reason : /* @__PURE__ */ new Error("Login cancelled")));
		};
		const timeout = setTimeout(() => {
			finish(() => reject(/* @__PURE__ */ new Error("Login timed out (60s)")));
		}, 6e4);
		signal?.addEventListener("abort", handleAbort, { once: true });
		if (signal?.aborted) {
			handleAbort();
			return;
		}
		if (options.skipOnInput) stopListeningForSkip = listenForSkipInput(() => finish(() => reject(new LoginCancelledError())));
		server.on("request", (req, res) => {
			const url = new URL(req.url, `http://localhost:${port}`);
			if (url.pathname === "/callback") {
				const callbackState = url.searchParams.get("state");
				const token = url.searchParams.get("token");
				const refreshToken = url.searchParams.get("refresh_token");
				const userParam = url.searchParams.get("user");
				const orgId = url.searchParams.get("org");
				if (callbackState !== state || !token || !userParam || !orgId) {
					res.writeHead(400, { "Content-Type": "text/html" });
					res.end(callbackPage({ success: false }));
					return;
				}
				const user = JSON.parse(decodeURIComponent(userParam));
				res.writeHead(200, {
					"Content-Type": "text/html",
					Connection: "close"
				});
				res.end(callbackPage({ success: true }));
				finish(() => resolve({
					token,
					refreshToken,
					user,
					organizationId: orgId
				}));
			}
		});
	});
	const creds = {
		token: result.token,
		...result.refreshToken ? { refreshToken: result.refreshToken } : {},
		user: result.user,
		organizationId: result.organizationId
	};
	await saveCredentials(creds);
	console.info(`   Logged in as ${creds.user.email}\n`);
	return creds;
}
function isInteractive$1() {
	return Boolean(process.stdin.isTTY && process.stdout.isTTY) && !process.env.CI;
}
async function getToken(signal, options = {}) {
	signal?.throwIfAborted();
	const envToken = process.env.MASTRA_API_TOKEN;
	if (envToken) return envToken;
	const creds = await loadCredentials();
	signal?.throwIfAborted();
	if (!creds) {
		if (!isInteractive$1()) throw new Error("Not logged in. Run `mastra auth login` interactively or set MASTRA_API_TOKEN.");
		return (await login(signal, options)).token;
	}
	if (await verifyToken(creds.token, signal)) return creds.token;
	signal?.throwIfAborted();
	const refreshed = await tryRefreshToken(creds, signal);
	if (refreshed) return refreshed;
	signal?.throwIfAborted();
	if (!isInteractive$1()) throw new Error("Session expired. Run `mastra auth login` interactively or set MASTRA_API_TOKEN.");
	return (await login(signal, options)).token;
}
/**
* Validate that the user has access to the specified organization.
* Throws if the org is not in the user's org list.
*/
async function validateOrgAccess(token, orgId) {
	const { fetchOrgs } = await Promise.resolve().then(() => api_exports);
	if (!(await fetchOrgs(token)).some((o) => o.id === orgId)) throw new Error(`No access to organization ${orgId}. Run: mastra auth orgs`);
}
//#endregion
//#region src/commands/auth/api.ts
var api_exports = /* @__PURE__ */ __exportAll({ fetchOrgs: () => fetchOrgs });
async function fetchOrgs(token) {
	const { data, error, response } = await createApiClient(token).GET("/v1/auth/orgs");
	if (error) throwApiError("Failed to fetch orgs", response.status, error.detail);
	return data.organizations;
}
//#endregion
//#region src/commands/auth/orgs.ts
var OrgSelectionCancelledError = class extends Error {
	constructor() {
		super("Organization selection cancelled");
		this.name = "OrgSelectionCancelledError";
	}
};
function isInteractive() {
	return Boolean(process.stdin.isTTY && process.stdout.isTTY) && !process.env.CI;
}
/**
* Resolve the current org, auto-selecting if only one exists.
* If multiple orgs exist and none is currently set, prompts the user.
* Pass `{ forcePrompt: true }` to always prompt when there's more than one
* org, even if a current org is persisted. In non-interactive environments,
* a persisted current org is reused and otherwise a clear setup error is
* thrown instead of starting a prompt that cannot be answered.
*/
async function resolveCurrentOrg(token, opts = {}) {
	const orgs = await fetchOrgs(token);
	if (orgs.length === 0) throw new Error("No organizations found.");
	if (orgs.length === 1) return {
		orgId: orgs[0].id,
		orgName: orgs[0].name
	};
	const envOrgId = process.env.MASTRA_ORG_ID;
	if (envOrgId) {
		const match = orgs.find((o) => o.id === envOrgId);
		if (match) return {
			orgId: match.id,
			orgName: match.name
		};
	}
	const currentOrgId = await getCurrentOrgId();
	if (currentOrgId && (!opts.forcePrompt || !isInteractive())) {
		const match = orgs.find((o) => o.id === currentOrgId);
		if (match) return {
			orgId: match.id,
			orgName: match.name
		};
	}
	if (!isInteractive()) throw new Error("Multiple organizations found. Run `mastra auth orgs switch` interactively or set MASTRA_ORG_ID.");
	let selected;
	try {
		selected = await p.select({
			message: "Select an organization",
			initialValue: currentOrgId ?? void 0,
			options: orgs.map((o) => ({
				value: o.id,
				label: `${o.name}${o.id === currentOrgId ? " (current)" : ""}`,
				hint: o.id
			})),
			...opts.signal ? { signal: opts.signal } : {}
		});
	} catch (error) {
		if (opts.signal?.aborted && opts.exitOnCancel === false) throw new OrgSelectionCancelledError();
		throw error;
	}
	if (p.isCancel(selected)) {
		if (opts.exitOnCancel === false) throw new OrgSelectionCancelledError();
		p.cancel("Cancelled.");
		process.exit(0);
	}
	const org = orgs.find((o) => o.id === selected);
	if (org.id !== currentOrgId) await setCurrentOrgId(org.id);
	return {
		orgId: org.id,
		orgName: org.name
	};
}
async function listOrgsAction() {
	const token = await getToken();
	const currentOrgId = await getCurrentOrgId();
	const orgs = await fetchOrgs(token);
	if (orgs.length === 0) {
		console.info("\nNo organizations found.\n");
		return;
	}
	console.info("\nOrganizations:\n");
	for (const org of orgs) {
		const marker = org.id === currentOrgId ? " (current)" : "";
		const role = org.role ? ` [${org.role}]` : "";
		console.info(`  ${org.name}${role}${marker}`);
		console.info(`    ID: ${org.id}`);
	}
	console.info("");
}
async function switchOrgAction() {
	if (process.env.MASTRA_API_TOKEN) {
		console.error("\nCannot switch org when using MASTRA_API_TOKEN. Unset it and log in with: mastra auth login\n");
		process.exit(1);
	}
	if (process.env.MASTRA_ORG_ID) {
		console.error("\nCannot switch org when MASTRA_ORG_ID is set. Unset it to use persistent org selection.\n");
		process.exit(1);
	}
	const token = await getToken();
	const currentOrgId = await getCurrentOrgId();
	const orgs = await fetchOrgs(token);
	if (orgs.length === 0) {
		console.info("\nNo organizations found.\n");
		return;
	}
	if (orgs.length === 1) {
		console.info(`\nYou only have one organization: ${orgs[0].name}\n`);
		return;
	}
	const selected = await p.select({
		message: "Switch to organization",
		options: orgs.map((o) => ({
			value: o.id,
			label: `${o.name}${o.id === currentOrgId ? " (current)" : ""}`
		}))
	});
	if (p.isCancel(selected)) {
		p.cancel("Cancelled.");
		process.exit(0);
	}
	await setCurrentOrgId(selected);
	const org = orgs.find((o) => o.id === selected);
	console.info(`\nSwitched to ${org.name} (${org.id})\n`);
}
//#endregion
export { fetchOrgs as a, credentials_exports as c, loadCredentials as d, login as f, verifyToken as g, validateOrgAccess as h, switchOrgAction as i, getCurrentOrgId as l, tryRefreshToken as m, listOrgsAction as n, LoginCancelledError as o, saveCredentials as p, resolveCurrentOrg as r, clearCredentials as s, OrgSelectionCancelledError as t, getToken as u };

//# sourceMappingURL=orgs-DoKnmO72.js.map